import Enumeration from './Enumeration.component';

export default Enumeration;
